// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import HistoryFiltersContainer from '../../containers/history/GridsHistoryFiltersContainer';

const Nav = styled.nav`
  overflow: hidden;
  ${({ theme }) => theme.grids.desktopBloc}
`;

type Props = {
  className?: string;
};

const GridsHistoryMenuDesktop = ({ className }: Props) => {
  return (
    <Nav className={className}>
      <HistoryFiltersContainer />
    </Nav>
  );
};

export default GridsHistoryMenuDesktop;
